import React, { createContext, PropsWithChildren, useRef } from 'react';
import { create, Cache } from '@tv2/lib-graphql/core/cache';

export const QueryCacheContext = createContext<Cache>(create());

export function QueryCacheProvider({
  children,
  initialCache,
}: { initialCache?: Record<string, any> } & PropsWithChildren) {
  const cache = useRef(create(initialCache));
  return <QueryCacheContext.Provider value={cache.current}>{children}</QueryCacheContext.Provider>;
}

export function useQueryCache() {
  const cache = React.useContext(QueryCacheContext);
  return cache;
}
